import React from 'react';
import PropTypes from 'prop-types';
import FeaturedSearch from './FeaturedSearch';

function StoreFront({ searches, results, onClick }) {
    return (
        <div>
            {Object.keys(searches).map(id => {
                if (!(id in results)) return;

                const search = searches[id];
                const result = results[id];
                return (
                    <div className="store-front__item" key={search.title}>
                        <FeaturedSearch search={search} designers={result} onClick={onClick} />
                    </div>
                );
            })}
        </div>
    );
}

StoreFront.propTypes = {
    searches: PropTypes.object.isRequired,
    results: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default StoreFront;



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/StoreFront.jsx